import React from 'react';

import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { Space } from 'components/barbr';
import { ShopIcon } from 'components/Icon';
import { getProfileRoute } from 'appRoutes/routeHelpers';
import tiktokIcon from 'assets/icons/tiktok-color.png';
import instagramIcon from 'assets/icons/instagram-color.png';
import BarberProfileMetaChip from 'components/barberProfileMetaChip';

import ProfileCover from '../../components/cover';

const WebProfileBasicDetail = React.memo(({ detail }) => {
  const { about } = detail;
  const shop = (detail.shop_detail || []).length && detail.shop_detail[0];

  return (
    <div className='basic-detail'>
      <ProfileCover detail={detail} />
      <Card>
        <Space justify='space-between' align='center'>
          <BarberProfileMetaChip detail={detail} />
          <Space size={12} justify='justify-center'>
            <If condition={detail.instagram_url}>
              <a href={detail.instagram_url} target='_blank' rel='noreferrer'>
                <img width={20} height={20} alt='Instagram' src={instagramIcon} />
              </a>
            </If>
            <If condition={detail.tiktok_url}>
              <a href={detail.tiktok_url} target='_blank' rel='noreferrer'>
                <img src={tiktokIcon} alt='Tiktok' width={20} height={20} />
              </a>
            </If>
          </Space>
        </Space>
        <If condition={shop}>
          <Space size={12} className='shop'>
            <ShopIcon />
            <p className='flex-fill'>{shop.name}</p>
            <Link to={getProfileRoute(shop.username)}>View</Link>
          </Space>
        </If>
        {about && <p className='text-xl light about'>{about}</p>}
      </Card>
    </div>
  );
});

export default WebProfileBasicDetail;
